/*
Purpose: one-off popup shown after login when the super admin has flagged the centre
         as "Not Paid" (Centres Management > Payment). Not a block - OK just dismisses it.
Project: TCMS

Login.js stores the notice the backend returned with the token in
sessionStorage.payment_hold_notice ({title, message}); this reads it on the first
centre page after login and removes the key on OK, so it only shows once per login.
Wording lives in tcms-backend/API/config/payment_hold.php.
*/

import { useState } from "react";
import { Modal } from 'react-bootstrap';
import Button from '@mui/material/Button';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const STORAGE_KEY = 'payment_hold_notice';

function readNotice() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

function PaymentHoldNotice() {
    const [notice, setNotice] = useState(readNotice);

    const handleOk = () => {
        sessionStorage.removeItem(STORAGE_KEY);
        setNotice(null);
    };

    if (!notice) return null;

    return (
        <Modal show={true} onHide={handleOk} backdrop="static" centered>
            <Modal.Header>
                <span><WarningRoundedIcon color="warning" className="me-1" />{notice.title}</span>
            </Modal.Header>
            <Modal.Body>
                {String(notice.message || '').split(/\n\s*\n/).map((para, idx, all) => (
                    <p key={idx} className={idx === all.length - 1 ? 'mb-0' : ''}>{para}</p>
                ))}
            </Modal.Body>
            <Modal.Footer className='pt-0'>
                <div className="mx-auto d-flex gap-2">
                    <Button variant="contained" className="primary-filled" onClick={handleOk}>OK</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default PaymentHoldNotice;
